<template>
  <div :class="{'date-picker-mobile': state.isOpened }">
    <div class="header-mobile" @click="onToggleDatePicker(false)">
      <i class="fas fa-chevron-left icon"></i> Back
    </div>
    <div class="preset">
      <router-link
        :to="onPresetChoosen(range)"
        class="preset-item"
        v-for="(range, index) in ranges"
        :key="index">{{range.name}}
      </router-link>
    </div>
    <date-range-picker
      :class="{'active': isCustomRangeDateActived() }"
      :dateRange="dateRange"
      :startDate="dateRange.startDate"
      :endDate="dateRange.endDate"
      :locale-data="locale"
      :autoApply="false"
      :ranges="false"
      @update="updateValues"
      @toggle="onToggleDatePicker"
      :opens="opens"
      :dateFormat="dateFormat">
      <div slot="input" slot-scope="picker">
        <i class="fas fa-calendar-alt icon"></i>
        <span class="date" v-if="isCustomRangeDateActived()">
          {{transformDateToDisplay(dateRange.startDate)}} - {{transformDateToDisplay(dateRange.endDate)}}
        </span>
        <!-- show when perset apply on mobile view-->
        <span class="date date-preset-mobile"
          v-if="!isCustomRangeDateActived() && getCurrentPresetName()">
          {{ getCurrentPresetName() }}
        </span>
      </div>
    </date-range-picker>
  </div>
</template>

<script>
/* eslint vue/no-unused-vars: "off" */
import _ from 'lodash';
import { isAfter } from 'date-fns';
import DateRangePicker from 'vue2-daterange-picker';
import dateFormatter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormatter],
  props: ['ranges', 'dateRange', 'onChange', 'onPresetChoosen', 'isRangeDateSelected', 'disabledCustomDate'],
  components: {
    DateRangePicker,
  },
  data() {
    return {
      state: {
        isOpened: false,
      },
      opens: 'left',
      locale: {
        direction: 'ltr',
        format: 'DD-MM-YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        firstDay: 1,
        showWeekNumbers: true,
      },
    };
  },
  watch: {
    'state.isOpened': (value) => {
      if (value) {
        document.body.className = 'modal-opened';
      } else {
        document.body.className = '';
      }
    },
  },
  methods: {
    getCurrentPresetName() {
      const { range } = this.$route.query;
      const currentRange = _.find(this.ranges, item => item.key === range);
      if (currentRange) {
        return currentRange.name;
      }
      return '';
    },
    isCustomRangeDateActived() {
      return this.dateRange.startDate && this.dateRange.endDate;
    },
    dateFormat(classes, date) {
      const disabled = isAfter(new Date(date), new Date());
      return { ...classes, disabled };
    },
    onToggleDatePicker(isOpened) {
      this.state.isOpened = isOpened;
    },
    updateValues(data) {
      const startDate = this.formatDate(data.startDate);
      const endDate = this.formatDate(data.endDate);
      this.onChange({ startDate, endDate });
    },
  },
};
</script>

<style lang="scss">
@import '~vue2-daterange-picker/dist/vue2-daterange-picker.css';
@import '@/assets/scss/variables.scss';

.vue-daterange-picker ::v-deep .reportrange-text {
  padding: $spacer * 0.5 $spacer * 0.75;
  height: auto;
  border: 1px solid #eeeeee;
  // color: $body-color;
}

.vue-daterange-picker.active ::v-deep .reportrange-text {
  border-color: $primary;
  color: $primary;
}

.reportrange-text {
  padding: $spacer * 0.5 $spacer * 0.75 !important;
  height: auto !important;
  border: 1px solid #eeeeee !important;
}

.vue-daterange-picker.active {
  .icon {
    margin-right: 4px;
  }
}

.vue-daterange-picker.active ::v-deep {
  .daterangepicker td.active, .daterangepicker td.active:hover {
    background-color: $primary;
  }
}

.preset, .date-preset-mobile, .header-mobile {
  display: none;
}

@media (max-width: 575.98px) {


  .date-preset-mobile {
    margin-left: 4px;
    display: inline-block;
  }

  .date-picker-mobile {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 900;

    display: flex;
    flex-direction: row;


    .header-mobile {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 40px;
      z-index: 900;

      display: flex;
      background-color: white;
      padding: $spacer * 0.5 $spacer * 0.75;
      border-bottom: 1px solid #ddd;

      align-items: center;

      .icon {
        margin-right: 6px;
      }
    }

    .reportrange-text {
      display: none;
    }

    .preset {
      display: flex;
      flex: 0 0 110px;
      flex-direction: column;
      height: calc(100% - 53px);
      // border-right: 1px solid #ddd;
      // flex-wrap: wrap;
      padding: $spacer $spacer * 0.5;
      padding-top: $spacer * 3;

      .preset-item {
        // border: 1px solid $gray-300;
        font-size: $font-size-sm;

        padding: $spacer * 0.5 $spacer * 0.25;
        margin-bottom: $spacer * 0.25;
        margin-right: $spacer * 0.25;
      }
    }

    .vue-daterange-picker {
      height: calc(100% - 53px);
      padding-top: $spacer * 3;
    }

    .daterangepicker.opensleft {
      position: relative;
      top: auto;
      right: auto;
      border: none;
      margin-top: 0;

      &:before {
        display: none;
      }

      .drp-calendar {
        max-width: 100%;

        &.left {
          padding: 8px;
          padding-top: 0;
        }
      }

      .drp-buttons {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding-top: $spacer * 0.75;
        padding-bottom: $spacer * 0.75;
      }
    }
  }
}
</style>
